module.exports = "/_next/static/images/ancap-e1e246c56cee0f0ab3850adf74bf4f0e.png";